const it: Record<string, string> = {
  // --- Common / Shared ---
  "common.loading": "Caricamento...",
  "common.save": "Salva",
  "common.saving": "Salvataggio...",
  "common.cancel": "Annulla",
  "common.delete": "Elimina",
  "common.edit": "Modifica",
  "common.create": "Crea",
  "common.creating": "Creazione...",
  "common.close": "Chiudi",
  "common.copy": "Copia",
  "common.search": "Cerca...",
  "common.back": "Indietro",
  "common.next": "Avanti",
  "common.yes": "Sì",
  "common.no": "No",
  "common.active": "Attivo",
  "common.inactive": "Inattivo",
  "common.on": "On",
  "common.off": "Off",
  "common.name": "Nome",
  "common.email": "E-Mail",
  "common.domain": "Dominio",
  "common.slug": "Slug",
  "common.role": "Ruolo",
  "common.status": "Stato",
  "common.actions": "Azioni",
  "common.settings": "Impostazioni",
  "common.upload": "Carica",
  "common.uploading": "Caricamento...",
  "common.download": "Scarica",
  "common.remove": "Rimuovi",
  "common.add": "Aggiungi",
  "common.entries": "Voci",
  "common.entry": "Voce",
  "common.fields": "Campi",
  "common.preview": "Anteprima",
  "common.noLogo": "Nessun logo",
  "common.noIcon": "Nessuna icona",
  "common.noImage": "Nessuna immagine",
  "common.networkError": "Errore di rete",
  "common.connectionError": "Errore di connessione. Server non raggiungibile.",
  "common.errorOccurred": "Si è verificato un errore",
  "common.errorLoading": "Errore durante il caricamento",
  "common.errorSaving": "Errore durante il salvataggio",
  "common.errorDeleting": "Errore durante l'eliminazione",
  "common.errorUpdating": "Errore durante l'aggiornamento",
  "common.errorCreating": "Errore durante la creazione",
  "common.saved": "Salvato",
  "common.justNow": "adesso",
  "common.minutesAgo": "{n} min fa",
  "common.hoursAgo": "{n} h fa",
  "common.deleted": "Eliminato",
  "common.admin": "Admin",
  "common.editor": "Editor",
  "common.password": "Password",
  "common.live": "Live",
  "common.draft": "Bozza",
  "common.title": "Titolo",
  "common.all": "Tutti",
  "common.main": "Principale",
  "common.pleaseSelect": "Seleziona",
  "common.activate": "Attivare",
  "common.deactivate": "Disattivare",
  "common.error": "Errore",
  "common.date": "Data",
  "common.selected": "selezionati",
  "common.selectAll": "Seleziona tutti",
  "common.deselectAll": "Deseleziona tutti",
  "common.noResults": "Nessun risultato",
  "common.copied": "Copiato",
  "common.rename": "Rinomina",
  "common.reset": "Ripristina",

  // --- Auth / Login ---
  "auth.email": "E-Mail",
  "auth.password": "Password",
  "auth.emailPlaceholder": "nome@esempio.com",
  "auth.passwordPlaceholder": "Inserisci password",
  "auth.forgotPassword": "Password dimenticata?",
  "auth.login": "Accedi",
  "auth.loggingIn": "Accesso...",
  "auth.logout": "Esci",
  "auth.loginError": "E-Mail o password non corretti",
  "auth.connectionError": "Errore di connessione. Server non raggiungibile.",

  // --- Forgot Password ---
  "forgot.title": "Password dimenticata",
  "forgot.description": "Inserisci la tua e-mail. Riceverai un link per reimpostare la password.",
  "forgot.send": "Invia link",
  "forgot.sending": "Invio in corso...",
  "forgot.success": "E-Mail inviata",
  "forgot.successMsg": "Se esiste un account con questa e-mail, è stato inviato un link per reimpostare la password.",
  "forgot.backToLogin": "Torna al login",
  "forgot.error": "Si è verificato un errore.",

  // --- Reset Password ---
  "reset.checking": "Verifica del link...",
  "reset.newPassword": "Nuova password",
  "reset.confirmPassword": "Conferma password",
  "reset.minChars": "Almeno 12 caratteri",
  "reset.repeatPassword": "Ripeti password",
  "reset.tooShort": "La password deve avere almeno 12 caratteri.",
  "reset.mismatch": "Le password non coincidono.",
  "reset.charsNeeded": "Ancora {n} caratteri necessari",
  "reset.longEnough": "La password è abbastanza lunga",
  "reset.passwordsMismatch": "Le password non coincidono",
  "reset.submit": "Cambia password",
  "reset.submitting": "Modifica in corso...",
  "reset.masterError": "Non possibile",
  "reset.invalidLink": "Link non valido",
  "reset.masterMsg": "La password master può essere modificata solo nelle impostazioni del server.",
  "reset.expiredMsg": "Questo link non è valido o è scaduto.",
  "reset.requestNew": "Richiedi nuovo link",
  "reset.success": "Password modificata. Ora puoi accedere.",
  "reset.backToLogin": "Torna al login",

  // --- Admin Sidebar ---
  "adminSidebar.dashboard": "Dashboard",
  "adminSidebar.kunden": "Clienti",
  "adminSidebar.newKunde": "Nuovo cliente",
  "adminSidebar.settings": "Impostazioni",
  "adminSidebar.collapse": "Comprimi",

  // --- Admin Dashboard ---
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Panoramica di tutti i clienti",
  "dashboard.totalKunden": "Clienti totali",
  "dashboard.activeKunden": "Clienti attivi",
  "dashboard.cmsEnabled": "CMS attivati",
  "dashboard.newKunde": "+ Nuovo cliente",
  "dashboard.recentChanges": "Ultime modifiche",
  "dashboard.noChanges": "Nessuna modifica presente.",

  // --- Kunden List ---
  "kunden.title": "Clienti",
  "kunden.newKunde": "Nuovo cliente",
  "kunden.newPassword": "Nuova password:",
  "kunden.noResults": "Nessun risultato.",
  "kunden.empty": "Nessun cliente presente.",
  "kunden.modules": "Moduli",
  "kunden.cms": "CMS",
  "kunden.statusUpdated": "Stato aggiornato",
  "kunden.resetPassword": "Reimposta password",
  "kunden.openCms": "Apri CMS",
  "kunden.confirmDelete": "Eliminare davvero \"{name}\"?\nTutti i dati ({pages} pagine, {posts} post, {media} media) verranno eliminati definitivamente.",
  "kunden.deleted": "Cliente eliminato",

  // --- New Kunde ---
  "newKunde.title": "Nuovo cliente",
  "newKunde.sectionKunde": "Cliente",
  "newKunde.sectionUser": "Primo utente",
  "newKunde.sectionOptional": "Impostazioni opzionali",
  "newKunde.sectionModules": "Moduli",
  "newKunde.namePlaceholder": "Hotel Esempio",
  "newKunde.slugPlaceholder": "hotel-esempio",
  "newKunde.domainPlaceholder": "www.hotel-esempio.com",
  "newKunde.contactEmail": "E-Mail di contatto (opzionale)",
  "newKunde.contactPlaceholder": "info@hotel-esempio.com",
  "newKunde.loginEmail": "E-Mail login *",
  "newKunde.loginEmailPlaceholder": "max@hotel-esempio.com",
  "newKunde.generate": "Genera",
  "newKunde.orKey": "OpenRouter Key (opzionale)",
  "newKunde.orModel": "OpenRouter Model (opzionale)",
  "newKunde.orModelPlaceholder": "es. anthropic/claude-sonnet-4",
  "newKunde.cmsActive": "Attiva CMS subito",
  "newKunde.sendEmail": "Invia credenziali via e-mail",
  "newKunde.submit": "Crea cliente",
  "newKunde.submitting": "Creazione...",
  "newKunde.fillRequired": "Compilare tutti i campi obbligatori (Nome, Slug, Dominio).",
  "newKunde.fillUserRequired": "Compilare tutti i campi utente obbligatori (Nome, E-Mail, Password).",
  "newKunde.created": "Cliente {name} creato",
  "newKunde.emailSent": "Credenziali inviate via e-mail",
  "newKunde.emailFailed": "Impossibile inviare l'e-mail",

  // --- Kunde Detail (Tabs) ---
  "kundeDetail.pages": "Pagine",
  "kundeDetail.posts": "Post",
  "kundeDetail.media": "Media",
  "kundeDetail.aiGenerate": "Genera con AI",
  "kundeDetail.tabGeneral": "Generale",
  "kundeDetail.tabDesign": "Design",
  "kundeDetail.tabSeo": "SEO & Marketing",
  "kundeDetail.tabLegal": "Legale & Cookie",
  "kundeDetail.tabContent": "Contenuti",
  "kundeDetail.tabAccess": "Accesso",
  "kundeDetail.tabHistory": "Cronologia",
  "kundeDetail.changesSaved": "Modifiche salvate",
  "kundeDetail.notFound": "Cliente non trovato",
  "kundeDetail.confirmDelete": "Eliminare davvero \"{name}\"?\nTutti i dati ({pages} pagine, {posts} post, {media} media) verranno eliminati definitivamente.",
  "kundeDetail.deleted": "Cliente eliminato",
  "kundeDetail.aiModalTitle": "Genera pagina con AI",
  "kundeDetail.aiPageName": "Nome pagina",
  "kundeDetail.aiPageNamePlaceholder": "es. Home, Chi siamo, Contatti",
  "kundeDetail.aiDescription": "Descrizione *",
  "kundeDetail.aiDescPlaceholder": "Descrivi il contenuto della pagina. Es.: Una homepage per un hotel in Alto Adige con sezione hero, panoramica camere come cards e info contatti.",
  "kundeDetail.aiStyle": "Stile / Tono (opzionale)",
  "kundeDetail.aiStylePlaceholder": "es. professionale, amichevole, moderno",
  "kundeDetail.aiGenerating": "Generazione...",
  "kundeDetail.aiGenerateButton": "Genera",
  "kundeDetail.aiPageCreated": "Pagina \"{name}\" con {count} sezioni creata",
  "kundeDetail.previewTitle": "Anteprima testo generato",
  "kundeDetail.textCopied": "Testo copiato",
  "kundeDetail.pagesCreated": "{count} pagina/e creata/e ({names})",
  "kundeDetail.alreadyExists": "{count} già esistente/i",
  "kundeDetail.done": "Fatto",
  "kundeDetail.confirmDeleteOrKey": "Eliminare davvero la chiave OpenRouter?",
  "kundeDetail.confirmDeleteRedirect": "Eliminare davvero il reindirizzamento?",
  "kundeDetail.legalGenerateError": "Errore durante la generazione",

  // --- Kunde Detail: General Tab ---
  "general.contactEmail": "E-Mail di contatto",
  "general.contactPlaceholder": "info@cliente.com",
  "general.orKey": "OpenRouter Key (opzionale)",
  "general.keyDeleted": "Key eliminata",
  "general.keySaved": "Key salvata",
  "general.newKeyOnSave": "Nuova key verrà impostata al salvataggio",
  "general.noKey": "Nessuna key",
  "general.orModel": "OpenRouter Model (opzionale)",
  "general.orModelPlaceholder": "es. anthropic/claude-sonnet-4",
  "general.cmsActive": "CMS attivo",
  "general.kundeActive": "Cliente attivo",
  "general.systemPrompt": "System Prompt",
  "general.systemPromptPlaceholder": "System prompt personalizzato per il cliente...",
  "general.languages": "Lingue",
  "general.mainLanguage": "Lingua principale",
  "general.mainBadge": "(principale)",
  "general.availableLanguages": "Lingue disponibili",

  // --- Kunde Detail: Design Tab ---
  "design.branding": "Branding",
  "design.logo": "Logo",
  "design.uploadLogo": "Carica logo",
  "design.svgRecommended": "SVG consigliato per la migliore qualità",
  "design.orEnterUrl": "o inserisci URL",
  "design.favicon": "Favicon",
  "design.uploadFavicon": "Carica favicon",
  "design.faviconFormats": "SVG, PNG o ICO",
  "design.colors": "Colori",
  "design.primaryColor": "Colore primario",
  "design.secondaryColor": "Colore secondario",
  "design.backgroundColor": "Sfondo",
  "design.textColor": "Colore testo",
  "design.headingColor": "Titoli",
  "design.footerBg": "Sfondo footer",
  "design.typography": "Tipografia",
  "design.headings": "Titoli",
  "design.textElements": "Testo & Elementi",
  "design.preview": "Anteprima",
  "design.fontFamily": "Carattere",
  "design.systemFont": "— Font di sistema —",
  "design.customFont": "Font personalizzato (WOFF2/TTF/OTF)",
  "design.removeFont": "Rimuovi font",
  "design.fontWeight": "Peso",
  "design.fontSize": "Dimensione (rem)",
  "design.lineHeight": "Interlinea",
  "design.fontColor": "Colore",
  "design.textStyle": "Stile testo",
  "design.letterSpacing": "Spaziatura caratteri (em)",
  "design.normal": "Normale",
  "design.uppercase": "MAIUSCOLE",
  "design.lowercase": "minuscole",
  "design.capitalize": "Prima Lettera Maiuscola",
  "design.or": "o",
  "design.pasteUrl": "Incolla URL",
  "design.removeLogo": "Rimuovi logo",
  "design.removeFavicon": "Rimuovi favicon",
  "design.uploaded": "Caricato",
  "design.uploadFailed": "Caricamento fallito",
  "design.fontUploaded": "Font \"{name}\" caricato",
  "design.bodyLabel": "Contenuto",
  "design.previewH1": "Titolo principale",
  "design.previewH2": "Sottotitolo",
  "design.previewH3": "Sotto-sottotitolo",
  "design.previewH4": "Titolo piccolo",
  "design.previewBody": "Questo è un testo di esempio per il corpo del sito web.",
  "design.previewNav": "Home  Chi siamo  Contatti",
  "design.previewFooter": "© 2026 Nome azienda. Tutti i diritti riservati.",
  "design.previewButton": "Richiedi ora",

  // --- Kunde Detail: SEO Tab ---
  "seo.seoAnalytics": "SEO & Analytics",
  "seo.metaTitle": "Meta Title (standard)",
  "seo.metaTitlePlaceholder": "es. Bergblick Apartments",
  "seo.titleSuffix": "Title Suffix",
  "seo.titleSuffixPlaceholder": "es. | Bergblick Apartments",
  "seo.previewLabel": "Anteprima:",
  "seo.pageName": "Nome pagina",
  "seo.metaDescription": "Meta Description",
  "seo.metaDescPlaceholder": "Descrizione standard per i motori di ricerca (150-160 caratteri ottimali)",
  "seo.chars": "caratteri",
  "seo.metaKeywords": "Meta Keywords",
  "seo.metaKeywordsPlaceholder": "es. hotel, alto adige, vacanza",
  "seo.analyticsId": "Google Analytics ID",
  "seo.analyticsPlaceholder": "es. G-XXXXXXXXXX",
  "seo.tagManagerId": "Tag Manager ID",
  "seo.tagManagerPlaceholder": "es. GTM-XXXXXXX",
  "seo.tagManagerHint": "Google Tag Manager Container ID",
  "seo.noIndex": "Blocca sito per i motori di ricerca",
  "seo.noIndexHint": "Attiva noindex/nofollow su tutte le pagine. Consigliato per development/beta.",
  "seo.ogImage": "Immagine OG standard",
  "seo.ogImagePlaceholder": "https://... (1200×630px consigliato)",
  "seo.ogImageHint": "Utilizzata quando una pagina non ha la propria immagine OG. Consigliato: 1200×630px",
  "seo.branding": "Logo e favicon per i motori di ricerca",
  "seo.brandingHint": "File dedicati per Google & Co.: logo Schema.org (Knowledge Panel) e icona accanto al risultato di ricerca. Vuoto = logo/favicon dalla scheda «Design». Utile se il logo del sito è bianco e sparisce su sfondo chiaro.",
  "seo.logo": "Logo SEO",
  "seo.logoHint": "Soggetto scuro su sfondo chiaro o coprente, min. 112×112px, PNG o SVG.",
  "seo.favicon": "Favicon SEO",
  "seo.faviconHint": "Quadrata, min. 48×48px (Google), PNG, SVG o ICO.",
  "seo.brandingFallbackActive": "Attualmente viene usato il file della scheda «Design».",
  "seo.verification": "Verifica motori di ricerca",
  "seo.googleVerification": "Google Verification Code",
  "seo.googleVerificationHint": "Da Google Search Console → Impostazioni → Verifica proprietà",
  "seo.bingVerification": "Bing Verification Code",
  "seo.bingVerificationHint": "Da Bing Webmaster Tools",
  "seo.businessInfo": "Informazioni Business (Schema.org)",
  "seo.businessType": "Tipo Business",
  "seo.openingHours": "Orari di apertura (strutturati per Schema.org)",
  "seo.openingHoursFormat": "Formato: HH:MM-HH:MM (es. 08:00-18:00). Vuoto = chiuso in quel giorno.",
  "seo.timeExample": "es. 08:00-18:00",
  "seo.closedHint": "vuoto = chiuso",
  "seo.socialMedia": "Social Media",
  "seo.socialHint": "Utilizzati anche per Schema.org sameAs e link nel footer.",
  "seo.days.mo": "Lun",
  "seo.days.di": "Mar",
  "seo.days.mi": "Mer",
  "seo.days.do": "Gio",
  "seo.days.fr": "Ven",
  "seo.days.sa": "Sab",
  "seo.days.so": "Dom",

  // --- Kunde Detail: Legal Tab ---
  "legal.title": "Note legali",
  "legal.company": "Azienda",
  "legal.companyName": "Ragione sociale",
  "legal.companyNamePlaceholder": "es. Mustermann GmbH",
  "legal.legalForm": "Forma giuridica",
  "legal.noSelection": "— Nessuna selezione —",
  "legal.vatId": "Partita IVA",
  "legal.vatIdPlaceholder": "es. IT01234567890",
  "legal.taxCode": "Codice Fiscale",
  "legal.taxCodePlaceholder": "es. 01234567890",
  "legal.tradeRegister": "Registro Imprese",
  "legal.tradeRegisterPlaceholder": "es. BZ-123456",
  "legal.reaNumber": "Numero REA",
  "legal.address": "Indirizzo",
  "legal.street": "Via + Nr.",
  "legal.streetPlaceholder": "es. Via Esempio 1",
  "legal.zip": "CAP",
  "legal.zipPlaceholder": "es. 39100",
  "legal.city": "Città",
  "legal.cityPlaceholder": "es. Bolzano",
  "legal.province": "Provincia",
  "legal.provincePlaceholder": "es. BZ",
  "legal.country": "Paese",
  "legal.countryPlaceholder": "es. IT",
  "legal.contact": "Contatto",
  "legal.phone": "Telefono",
  "legal.phonePlaceholder": "es. +39 0471 123456",
  "legal.emailImprint": "E-Mail (note legali)",
  "legal.emailPlaceholder": "es. info@azienda.it",
  "legal.pec": "PEC",
  "legal.pecPlaceholder": "es. azienda@pec.it",
  "legal.websiteUrl": "URL sito web",
  "legal.websitePlaceholder": "es. https://www.azienda.it",
  "legal.responsible": "Responsabile / Capitale",
  "legal.owner": "Titolare / Rappresentante legale",
  "legal.ownerPlaceholder": "es. Mario Rossi",
  "legal.capital": "Capitale sociale",
  "legal.capitalPlaceholder": "es. 10.000,00 EUR",
  "legal.mediaSources": "Crediti contenuti media",
  "legal.mediaSourcesPlaceholder": "Foto: © Mario Rossi / Shutterstock\nIcone: Lucide Icons (Licenza MIT)\nVideo: © Azienda XY",
  "legal.mediaSourcesHint": "Fonti per immagini, video e altri contenuti media (una fonte per riga)",
  "legal.imprintTexts": "Testi note legali (opzionale)",
  "legal.imprintTextsHint": "Lasciare vuoto per generazione automatica dai dati sopra.",
  "legal.privacyTexts": "Testi privacy (opzionale)",
  "legal.privacyTextsHint": "Lasciare vuoto per generazione automatica dai dati del cliente.",
  "legal.cookieBanner": "Cookie Banner",
  "legal.cookieActive": "Cookie banner attivo",
  "legal.privacyUrl": "URL Privacy",
  "legal.privacyUrlPlaceholder": "es. /privacy o https://...",
  "legal.allDefaults": "Inserisci tutti i testi standard",
  "legal.generatePages": "Genera pagine automaticamente",
  "legal.generatePagesDesc": "Crea automaticamente le pagine Note legali e Privacy dai dati inseriti. Le pagine già esistenti **non** vengono sovrascritte.",
  "legal.generatePagesHint": "Inserire prima ragione sociale, città e e-mail.",
  "legal.generating": "Generazione...",
  "legal.generateButton": "Crea pagine Note legali + Privacy",

  // --- Kunde Detail: Content Tab ---
  "content.openingHours": "Orari di apertura",
  "content.openingHoursLabel": "Orari di apertura (testo libero)",
  "content.openingHoursPlaceholder": "Lun-Ven: 08:00-18:00\nSab: 09:00-13:00\nDom: chiuso",
  "content.contactForm": "Modulo di contatto",
  "content.recipientEmail": "E-Mail destinatario",
  "content.recipientPlaceholder": "es. info@azienda.it",
  "content.defaultSubject": "Oggetto standard",
  "content.subjectPlaceholder": "es. Richiesta dal sito web",
  "content.sendTestAnfrage": "Invia richiesta di test",
  "content.testAnfrageSent": "2 email di test inviate a {email} ({sent})",
  "content.testAnfrageError": "Impossibile inviare le email di test",
  "content.testAnfrageHint": "Invia 2 email all'indirizzo Super Admin: notifica (al gestore) + conferma (al mittente). Usa il logo e il colore primario del cliente.",
  "content.booking": "Prenotazione",
  "content.bookingUrl": "URL prenotazione esterna",
  "content.bookingPlaceholder": "es. https://booking.com/hotel/...",
  "content.bookingHint": "es. Booking.com o sistema proprio",
  "content.footerText": "Testo footer",
  "content.footerTextPlaceholder": "es. © 2026 Azienda Srl. Tutti i diritti riservati.",
  "content.footerTextHint": "Breve testo visualizzato nel footer del sito web",
  "content.specialPages": "Pagine speciali",
  "content.thankYouImage": "Immagine pagina di ringraziamento",
  "content.thankYouPlaceholder": "URL dalla libreria media",
  "content.thankYouHint": "Mostrata dopo l'invio del modulo",
  "content.errorPageImage": "Immagine pagina errore 404",
  "content.errorPageHint": "Mostrata per pagine non trovate",
  "content.modules": "Moduli",
  "content.modulesManaged": "I moduli vengono gestiti dalla propria pagina di configurazione.",
  "content.configureModules": "Configura moduli",

  // --- Kunde Detail: Access Tab ---
  "access.permissions": "Permessi utenti",
  "access.masterHint": "Il master ha sempre accesso completo. L'admin non può avere meno permessi dell'editor.",
  "access.permission": "Permesso",
  "access.savePermissions": "Salva permessi",
  "access.editPages": "Modifica pagine",
  "access.createPages": "Crea pagine",
  "access.deletePages": "Elimina pagine",
  "access.editMeta": "Modifica SEO/Meta",
  "access.uploadMedia": "Carica media",
  "access.deleteMedia": "Elimina media",
  "access.editModules": "Modifica moduli",
  "access.createModules": "Crea moduli",
  "access.deleteModules": "Elimina moduli",
  "access.useChat": "Usa chat",
  "access.manageUsers": "Gestisci utenti",
  "access.users": "Utenti",
  "access.newUser": "Nuovo utente",
  "access.noUsers": "Nessun utente creato.",
  "access.noUsersHint": "Crea un utente per consentire al cliente di accedere.",
  "access.lastLogin": "Ultimo accesso",
  "access.editUser": "Modifica utente",
  "access.generatedPassword": "Password generata:",
  "access.sendCredentials": "Invia credenziali via e-mail",
  "access.namePlaceholder": "Mario Rossi",
  "access.emailPlaceholder": "mario@esempio.it",
  "access.userCreated": "Utente creato",
  "access.userUpdated": "Utente aggiornato",
  "access.userDeleted": "Utente eliminato",
  "access.newPasswordToast": "Nuova password: {password}",
  "access.confirmDeleteUser": "Eliminare davvero \"{name}\"?",
  "access.deactivate": "Disattiva",
  "access.activate": "Attiva",

  // --- Kunde Detail: History Tab ---
  "history.noChanges": "Nessuna modifica presente.",

  // --- Redirects ---
  "redirects.title": "Reindirizzamenti",
  "redirects.new": "Nuovo reindirizzamento",
  "redirects.from": "Da",
  "redirects.fromPlaceholder": "/vecchio-percorso",
  "redirects.to": "A",
  "redirects.toPlaceholder": "/nuovo-percorso o https://...",
  "redirects.type": "Tipo",
  "redirects.permanent": "301 (Permanente)",
  "redirects.temporary": "302 (Temporaneo)",
  "redirects.created": "Reindirizzamento creato",
  "redirects.deleted": "Reindirizzamento eliminato",
  "redirects.empty": "Nessun reindirizzamento creato.",
  "redirects.fromRequired": "Da e A sono campi obbligatori",
  "redirects.fromSlash": "Il percorso Da deve iniziare con /",
  "redirects.toSlash": "Il percorso A deve iniziare con / o https://",
  "redirects.sameError": "Da e A non possono essere identici",
  "redirects.export": "Esporta link",
  "redirects.exportTitle": "Link disponibili",
  "redirects.exportEmpty": "Nessun link trovato.",
  "redirects.exportError": "Errore durante il caricamento dei link",
  "redirects.exportFilter": "Filtra per URL o titolo...",
  "redirects.exportHint": "Tutti gli URL delle pagine attuali del cliente (incl. slug multilingua).",
  "redirects.copyAll": "Copia tutto",
  "redirects.useAsTarget": "Come destinazione",
  "redirects.exportCsv": "CSV (Excel)",

  // --- Admin Settings ---
  "adminSettings.title": "Impostazioni",
  "adminSettings.appearance": "Aspetto",
  "adminSettings.logoHint": "Il logo viene mostrato nella sidebar, login e nelle e-mail. Consigliato: PNG o SVG, trasparente, max 400x120px.",
  "adminSettings.uploadLogo": "Carica logo",
  "adminSettings.svgBest": "SVG consigliato per la migliore qualità",
  "adminSettings.loginBg": "Immagine sfondo login",
  "adminSettings.loginBgHint": "Mostrata nelle pagine login, password dimenticata e reset. Consigliato: min 1920x1080px, JPG o WebP.",
  "adminSettings.uploadImage": "Carica immagine",
  "adminSettings.confirmRemoveLogo": "Rimuovere davvero il logo?",
  "adminSettings.logoUploaded": "Logo caricato",
  "adminSettings.logoRemoved": "Logo rimosso",
  "adminSettings.confirmRemoveBg": "Rimuovere davvero l'immagine di sfondo?",
  "adminSettings.bgUploaded": "Immagine di sfondo caricata",
  "adminSettings.bgRemoved": "Immagine di sfondo rimossa",
  "adminSettings.onlyImageFormats": "Solo PNG, JPG, SVG o WebP consentiti",
  "adminSettings.fileTooLarge5": "File troppo grande (max 5MB)",
  "adminSettings.onlyImageFormatsNoBg": "Solo PNG, JPG o WebP consentiti",
  "adminSettings.fileTooLarge10": "File troppo grande (max 10MB)",
  "adminSettings.uploadFailed": "Caricamento fallito",
  "adminSettings.removeFailed": "Errore durante la rimozione",
  "adminSettings.emailSystem": "Sistema E-Mail",
  "adminSettings.statusLabel": "Stato:",
  "adminSettings.emailConnected": "Resend connesso",
  "adminSettings.emailNotConfigured": "Non configurato",
  "adminSettings.sender": "Mittente",
  "adminSettings.alertEmail": "E-Mail Alert",
  "adminSettings.sendTest": "Invia e-mail di test",
  "adminSettings.sendingTest": "Invio...",
  "adminSettings.testSent": "E-Mail di test inviata a {email}",
  "adminSettings.testFailed": "Impossibile inviare l'e-mail",
  "adminSettings.masterPassword": "Cambia password master",
  "adminSettings.currentPassword": "Password attuale",
  "adminSettings.newPassword": "Nuova password",
  "adminSettings.minChars": "Almeno 8 caratteri",
  "adminSettings.fillBoth": "Compilare entrambi i campi.",
  "adminSettings.passwordChanged": "Password modificata con successo",
  "adminSettings.changePassword": "Cambia password",
  "adminSettings.serverInfo": "Informazioni server",
  "adminSettings.nodeJs": "Node.js",
  "adminSettings.platform": "Piattaforma",
  "adminSettings.uptime": "Uptime",
  "adminSettings.environment": "Ambiente",
  "adminSettings.database": "Database",

  // --- Kunde Sidebar ---
  "kundeSidebar.overview": "Panoramica",
  "kundeSidebar.pages": "Pagine",
  "kundeSidebar.blog": "Blog",
  "kundeSidebar.chat": "Chat",
  "kundeSidebar.users": "Utenti",
  "kundeSidebar.media": "Media",
  "kundeSidebar.settings": "Impostazioni",
  "kundeSidebar.collapse": "Comprimi",
  "kundeSidebar.openWebsite": "Apri sito web",

  // --- Kunde Overview ---
  "overview.title": "Panoramica",
  "overview.welcome": "Benvenuto nel CMS",
  "overview.pages": "Pagine",
  "overview.blogPosts": "Post del blog",
  "overview.media": "Media",
  "overview.quickAccess": "Accesso rapido",
  "overview.editPages": "Modifica pagine",
  "overview.manageBlog": "Gestisci blog",
  "overview.uploadMedia": "Carica media",
  "overview.settings": "Impostazioni",
  "overview.recentChanges": "Ultime modifiche",
  "overview.settingsDesc": "Contatto, password, SEO",
  "overview.modules": "Moduli",
  "overview.chatDesc": "Modifica contenuti con IA",
  "overview.users": "Utenti",
  "overview.usersDesc": "Gestisci utenti",

  // --- Super Admin Banner ---
  "superAdmin.banner": "Vista Super Admin:",
  "superAdmin.backToAdmin": "Torna all'admin",
  "superAdmin.badge": "Super Admin",
  "superAdmin.switchKunde": "Cambia cliente",
  "superAdmin.searchKunde": "Cerca cliente…",
  "superAdmin.noKunden": "Nessun cliente trovato",
  "superAdmin.loadError": "Impossibile caricare i clienti",

  // --- Sidebar (condivisa) ---
  "sidebar.language": "Lingua",
  "sidebar.expand": "Espandi",
  "sidebar.groupContent": "Contenuti",
  "sidebar.groupAi": "IA",
  "sidebar.groupAdmin": "Amministrazione",
  "sidebar.roleMaster": "Master",
  "sidebar.roleAdmin": "Admin",
  "sidebar.roleEditor": "Editor",

  // --- Kunde Layout Errors ---
  "kundeLayout.notAuthorized": "Non autorizzato. Effettua nuovamente il login.",
  "kundeLayout.loadError": "Errore durante il caricamento dei dati cliente.",
  "kundeLayout.networkError": "Errore di rete. Server non raggiungibile.",
  "kundeLayout.genericError": "Impossibile caricare i dati del cliente.",
  "kundeLayout.retry": "Riprova",

  // --- Pages Editor ---
  "pages.title": "Pagine",
  "pages.newPage": "Nuova pagina",
  "pages.normal": "Pagine di contenuto",
  "pages.landing": "Landing page",
  "pages.all": "Tutte le pagine",
  "pages.isLanding": "Landing page",
  "pages.isLandingDesc": "Non compare nel menu",
  "pages.normalPage": "Pagina normale",
  "pages.landingShort": "Landing",
  "pages.pageShort": "Pagina",
  "pages.filterLabel": "Mostra",
  "pages.import": "Importa",
  "pages.export": "Esporta",
  "pages.searchPlaceholder": "Cerca pagine…",
  "pages.clearSearch": "Cancella ricerca",
  "pages.noSearchResults": "Nessuna pagina trovata",
  "pages.collapse": "Comprimi sottopagine",
  "pages.expand": "Espandi sottopagine",
  "pages.viewLive": "Visualizza live",
  "pages.translationMissing": "{fehlend} di {gesamt} testi mancanti in {sprache}",
  "pages.translationMissingChildren": "incl. sottopagine",
  "pages.translationIncomplete": "incompleto",
  "pages.notInMenu": "Non nel menu",
  "pages.saved": "Pagina salvata",
  "pages.deleted": "Pagina eliminata",
  "pages.created": "Pagina creata",
  "pages.sectionCopied": "Sezione copiata",
  "pages.sectionCopiedTo": "Sezione copiata su \"{page}\"",
  "pages.duplicate": "Duplica",
  "pages.duplicatePage": "Duplica pagina",
  "pages.duplicated": "Pagina duplicata",
  "pages.copySuffix": "Copia",
  "pages.duplicateSource": "Copia di \"{page}\" con tutte le sezioni, i dati SEO e le traduzioni.",
  "pages.duplicateShowInMenu": "Mostra la copia nel menu",
  "pages.duplicateShowInMenuDesc": "Per impostazione predefinita la copia resta nascosta finché non viene modificata.",
  "pages.copySection": "Copia sezione",
  "pages.copyToOtherPage": "Copia su altra pagina",
  "pages.copyError": "Errore durante la copia",
  "pages.uniqueIds": "Gli ID delle sezioni devono essere univoci",
  "pages.invalidId": "ID sezione non valido: \"{id}\"",
  "pages.invalidClass": "Classe CSS non valida: \"{class}\"",
  "pages.parentPage": "Pagina principale",
  "pages.template": "Modello",
  "pages.homepage": "Home",
  "pages.hidden": "nascosta",
  "pages.sectionId": "ID / Ancora",
  "pages.cssClass": "Classe CSS",
  "pages.seo": "SEO",
  "pages.metaTitle": "Meta Title",
  "pages.metaDescription": "Meta Description",
  "pages.ogImage": "Immagine OG",
  "pages.socialMedia": "Social Media (Open Graph)",
  "pages.socialMediaDesc": "Titolo, descrizione e immagine per i link condivisi (WhatsApp, Facebook, LinkedIn). Vuoto = vengono usati Meta Title / Meta Description.",
  "pages.ogTitle": "Titolo OG",
  "pages.ogTitlePlaceholder": "Titolo per la condivisione (vuoto = Meta Title)",
  "pages.ogDescription": "Descrizione OG",
  "pages.ogDescPlaceholder": "Descrizione per la condivisione (vuoto = Meta Description)",
  "pages.canonical": "Canonico",
  "pages.schema": "Schema",
  "pages.modulAsSubmenu": "Modulo come sottomenu",
  "pages.selectModule": "Seleziona modulo",
  "pages.onThisPage": "Su questa pagina",
  "pages.addSection": "Aggiungi sezione",
  "pages.unnamedSection": "Nuova sezione",
  "pages.addField": "Aggiungi campo",
  "pages.advancedIdClass": "Avanzate · ID e classe CSS",
  "pages.addElement": "Aggiungi elemento",
  "pages.noElements": "Nessun elemento. Aggiungi il primo qui sotto.",
  "pages.elementPalette": "Scegli elemento",
  "pages.noPageSelected": "Seleziona una pagina dalla lista o creane una nuova.",
  "pages.fieldExists": "Il campo esiste già",
  "pages.fieldDuplicated": "{field} duplicato",
  "pages.noTranslatableTexts": "Nessun testo traducibile trovato",
  "pages.chooseOtherLanguage": "Scegli un'altra lingua di destinazione",
  "pages.textsTranslated": "{count} testi tradotti",
  "pages.textsTranslatedPartial": "{count} testi tradotti, {missing} non riusciti – riprova la traduzione",
  "pages.translationFailed": "Traduzione fallita",
  "pages.confirmDeleteEntry": "Eliminare davvero la voce?",
  "pages.hide": "Nascondi",
  "pages.show": "Mostra",
  "pages.idAndClass": "ID & Classe",
  "pages.duplicateLabel": "Duplica {label}",
  "pages.removeLabel": "Rimuovi {label}",
  "pages.confirmDelete": "Eliminare davvero la pagina?",
  "pages.selectMultiple": "Seleziona più pagine",

  // --- Seiten: Versionsverlauf ---
  "versions.title": "Versioni",
  "versions.open": "Mostra versioni",
  "versions.empty": "Ancora nessuna versione. Vengono create al salvataggio.",
  "versions.current": "Stato attuale",
  "versions.loadedBadge": "Caricata",
  "versions.view": "Visualizza",
  "versions.loadError": "Impossibile caricare le versioni",
  "versions.loaded": "Versione del {datum} caricata – non ancora salvata.",
  "versions.restore": "Ripristina",
  "versions.discard": "Annulla",
  "versions.hint": "Vengono conservate le ultime {n} versioni di ogni pagina.",
  "versions.source.ausgangsstand": "Stato iniziale",
  "versions.source.speichern": "Salvato",
  "versions.source.wiederherstellung": "Ripristinato",
  "versions.source.ki": "IA",
  "versions.source.chat": "Chat",
  "versions.source.import": "Import",
  "versions.change.sectionChanged1": "1 sezione modificata",
  "versions.change.sectionChangedN": "{n} sezioni modificate",
  "versions.change.sectionAdded1": "1 sezione aggiunta",
  "versions.change.sectionAddedN": "{n} sezioni aggiunte",
  "versions.change.sectionRemoved1": "1 sezione rimossa",
  "versions.change.sectionRemovedN": "{n} sezioni rimosse",
  "versions.change.order": "Ordine",
  "versions.change.title": "Titolo",
  "versions.change.slug": "Slug",
  "versions.change.seo": "SEO",
  "versions.change.settings": "Impostazioni",
  "versions.change.none": "Nessuna modifica ai contenuti",
  "versions.detail.show": "Mostra dettagli",
  "versions.detail.hide": "Nascondi dettagli",
  "versions.detail.more": "+ {n} altre modifiche",
  "versions.detail.empty": "vuoto",
  "versions.detail.bereich.seite": "Pagina",
  "versions.detail.bereich.seo": "SEO",
  "versions.detail.bereich.einstellungen": "Impostazioni",
  "versions.detail.sectionAdded": "Sezione aggiunta",
  "versions.detail.sectionRemoved": "Sezione rimossa",
  "versions.detail.fieldAdded": "aggiunto",
  "versions.detail.fieldRemoved": "rimosso",
  "versions.detail.titel": "Titolo",
  "versions.detail.slug": "Slug",
  "versions.detail.name": "Nome",
  "versions.detail.sichtbar": "Visibile",
  "versions.detail.anker": "ID / ancora",
  "versions.detail.klasse": "Classe CSS",
  "versions.detail.feldReihenfolge": "Ordine dei campi",
  "versions.detail.sektionReihenfolge": "Ordine delle sezioni",
  "versions.detail.elternseite": "Pagina principale",
  "versions.detail.modulUntermenue": "Modulo come sottomenu",
  "versions.detail.menuVerhalten": "Comportamento menu",
  "versions.detail.menuNeuesTab": "Apri in nuova scheda",
  "versions.detail.menuUrl": "URL menu",
  "versions.detail.landing": "Landing page",
  "versions.detail.nurSprachen": "Pubblicato in",

  "pages.unsavedChanges": "Modifiche non salvate",
  "pages.savedAgo": "Salvato · {zeit}",
  "pages.translateShort": "Traduci",
  "pages.new": "Nuovo",
  "pages.emptyPage": "Pagina vuota",
  "pages.collapseChildren": "Comprimi sottopagine",
  "pages.expandChildren": "Espandi sottopagine",
  "pages.pageActions": "Azioni pagina",
  "pages.selectAll": "Seleziona tutto ({count})",
  "pages.selectAllResults": "Seleziona tutti i risultati ({count})",
  "pages.deleteSelected": "Elimina {count}",
  "pages.confirmBulkDelete": "Eliminare davvero {count} pagine?\nL'operazione non può essere annullata.",
  "pages.bulkDeleted": "{count} pagine eliminate",
  "pages.homepageNotDeletable": "La homepage non può essere eliminata",
  "pages.autoTranslate": "Traduzione automatica",
  "pages.sourceLanguage": "Lingua di origine",
  "pages.targetLanguage": "Lingua di destinazione",
  "pages.translate": "Traduci",
  "pages.translating": "Traduzione...",
  "pages.deleteTranslation": "Elimina traduzione",
  "pages.translationDeleted": "Traduzione eliminata – salva la pagina per applicare le modifiche",
  "pages.deleteTranslationWarning": "Questa azione rimuove tutti i contenuti tradotti per la lingua selezionata su questa pagina.",
  "pages.deleteTranslationConfirm": "Voglio eliminare definitivamente la traduzione",
  "pages.fallbackHint": "Lingua principale",
  "pages.clearFieldTranslation": "Elimina traduzione per questo campo",
  "pages.fieldTranslationCleared": "Traduzione del campo eliminata",
  "pages.removeFromMenu": "Nascondi dalla navigazione",
  "pages.showInMenu": "Mostra nella navigazione",
  "pages.confirmDeleteSection": "Eliminare davvero la sezione?",
  "pages.noPages": "Nessuna pagina presente.",
  "pages.selectPage": "Seleziona pagina",
  "pages.pageTitle": "Titolo pagina",
  "pages.sections": "Sezioni",
  "pages.noSections": "Nessuna sezione presente.",
  "pages.selectSection": "Seleziona sezione",
  "pages.content": "Contenuto",
  "pages.main": "Principale",
  "pages.characters": "Caratteri",
  "pages.metaTitlePlaceholder": "Titolo per i motori di ricerca",
  "pages.metaTitlePlaceholderLong": "Titolo alternativo per i risultati di ricerca",
  "pages.metaDescPlaceholder": "Descrizione per i motori di ricerca",
  "pages.schemaType": "Tipo di schema",
  "pages.canonicalUrl": "URL canonico",
  "pages.canonicalPlaceholder": "https://...",
  "pages.ogImagePlaceholder": "URL immagine per social media",
  "pages.previewImage": "Immagine anteprima",
  "pages.modulAsSubmenuDesc": "Le voci del modulo vengono mostrate come sottopunti nella navigazione",
  "pages.noParent": "Nessuna (livello superiore)",
  "pages.childrenWillBecomeTopLevel": "Le sottopagine di questa pagina verranno spostate al livello superiore.",
  "pages.menuTitle": "Comportamento menu",
  "pages.menuDesc": "Come si comporta questa voce nel menu principale?",
  "pages.menuVerhaltenSeite": "Link a questa pagina",
  "pages.menuVerhaltenSeiteDesc": "Predefinito – apre la pagina",
  "pages.menuVerhaltenLabel": "Solo etichetta (nessun link)",
  "pages.menuVerhaltenLabelDesc": "Viene mostrato nel menu ma non è cliccabile",
  "pages.menuVerhaltenWeiterleitung": "Reindirizzamento",
  "pages.menuVerhaltenWeiterleitungDesc": "Reindirizza a un altro URL (interno o esterno)",
  "pages.menuUrlLabel": "URL di destinazione",
  "pages.menuUrlPlaceholder": "https://… o /percorso",
  "pages.menuUrlHelp": "Inserisci per lingua. Vuoto = usa la lingua principale come fallback.",
  "pages.menuNeuesTab": "Apri in nuova scheda",
  "pages.nurSprachenTitle": "Pubblicata in",
  "pages.nurSprachenDesc": "Lingue in cui la pagina appare sul sito. Predefinito: tutte.",
  "pages.nurSprachenHinweis": "Non pubblicata in: {sprachen}. Le visite a queste versioni linguistiche vengono reindirizzate a una versione pubblicata; menu, sitemap e hreflang le omettono.",
  "pages.nurSprachenMinEine": "Almeno una lingua deve rimanere attiva",
  "pages.homepageDesc": "Questa pagina verrà utilizzata come home",
  "pages.slug": "Slug",
  "pages.slugAutoGenerated": "Generato automaticamente dal titolo",
  "pages.fieldName": "Nome campo",
  "pages.optionsComma": "Opzioni (separate da virgola)",
  "pages.customFields": "Campi personalizzati",
  "pages.imagePosition": "Posizione immagine",
  "pages.spacing": "Spaziatura",
  "pages.entry": "Voce",
  "pages.module": "Modulo",
  "pages.layout": "Layout",
  "pages.layoutCards": "Schede",
  "pages.layoutList": "Lista",
  "pages.layoutSlider": "Slider",
  "pages.count": "Numero",
  "pages.sorting": "Ordinamento",
  "pages.sortNewest": "Più recenti",
  "pages.sortOrder": "Ordine",
  "pages.sortAlphabetical": "Titolo",
  "pages.titlePlaceholder": "Titolo della pagina",
  "pages.translatableFieldsFound": "{count} campi traducibili trovati",
  "pages.inclPageTitle": "incl. titolo pagina",
  "pages.overwriteTranslations": "Sovrascrivi traduzioni esistenti",
  "pages.overwriteTranslationsHint": "Ritraduce tutti i campi, anche quelli già tradotti.",
  "pages.idTaken": "Questo ID è già in uso",

  // --- Blog ---
  "blog.title": "Blog",
  "blog.newPost": "Nuovo post",
  "blog.empty": "Nessun post presente.",
  "blog.confirmDelete": "Eliminare davvero il post?",
  "blog.deleted": "Post eliminato",

  // --- Blog New ---
  "blogNew.title": "Nuovo post",
  "blogNew.titleLabel": "Titolo *",
  "blogNew.titlePlaceholder": "Titolo del post",
  "blogNew.slugLabel": "Slug *",
  "blogNew.slugPlaceholder": "slug-post",
  "blogNew.excerptLabel": "Estratto",
  "blogNew.excerptPlaceholder": "Breve descrizione...",
  "blogNew.contentLabel": "Contenuto",
  "blogNew.contentPlaceholder": "Contenuto del post...",
  "blogNew.imageLabel": "URL immagine",
  "blogNew.imagePlaceholder": "/uploads/...",
  "blogNew.published": "Pubblicato",
  "blogNew.draft": "Bozza",
  "blogNew.required": "Titolo e slug obbligatori",
  "blogNew.created": "Post creato",
  "blogNew.submit": "Crea post",

  // --- Blog Edit ---
  "blogEdit.title": "Modifica post",
  "blogEdit.notFound": "Post non trovato.",
  "blogEdit.published": "Post pubblicato",
  "blogEdit.saved": "Post salvato",
  "blogEdit.deleted": "Post eliminato",
  "blogEdit.confirmDelete": "Eliminare davvero il post?",
  "blogEdit.titleLabel": "Titolo",
  "blogEdit.slugLabel": "Slug",
  "blogEdit.excerptLabel": "Estratto",
  "blogEdit.contentLabel": "Contenuto",
  "blogEdit.imageLabel": "URL immagine",

  // --- Module ---
  "module.title": "Moduli",
  "module.newModule": "Nuovo modulo",
  "module.empty": "Nessun modulo",
  "module.emptyHint": "Crea un nuovo modulo per questo cliente.",
  "module.detailPage": "Pagina dettaglio",
  "module.categories": "Categorie",
  "module.publication": "Pubblicazione",
  "module.expiry": "Scadenza",
  "module.configure": "Configura",
  "module.configureTitle": "Configura modulo",
  "module.newTitle": "Nuovo modulo",
  "module.nameLabel": "Nome",
  "module.namePlaceholder": "es. Camere",
  "module.keyLabel": "Key",
  "module.keyPlaceholder": "auto",
  "module.iconLabel": "Icona",
  "module.hasDetail": "Ha pagina dettaglio",
  "module.hasCategories": "Ha categorie",
  "module.hasPublication": "Data di pubblicazione",
  "module.hasExpiry": "Data di scadenza",
  "module.unlimitedUpload": "Dimensione upload illimitata",
  "module.loadTemplate": "Carica modello",
  "module.fieldCount": "Campi ({count})",
  "module.addField": "Campo",
  "module.noFields": "Nessun campo. Scegli un modello o aggiungi campi.",
  "module.nameKeyRequired": "Nome e key obbligatori",
  "module.updated": "Modulo aggiornato",
  "module.created": "Modulo creato",
  "module.confirmDelete": "Eliminare davvero il modulo \"{name}\"?\n{count} voci verranno eliminate.",
  "module.deleted": "Modulo eliminato",
  "module.fieldLabel": "Label",
  "module.fieldKey": "key",
  "module.fieldRequired": "Obbligatorio",
  "module.fieldPlaceholder": "Placeholder (opzionale)",
  "module.fieldOptions": "Opzioni (separate da virgola)",
  "module.fieldMultiple": "Multiplo",

  // --- Module Entries ---
  "moduleEntries.notFound": "Modulo non trovato",
  "moduleEntries.noEntries": "Nessuna voce",
  "moduleEntries.editEntry": "Modifica voce",
  "moduleEntries.newEntry": "Nuova voce",
  "moduleEntries.titleRequired": "Titolo obbligatorio",
  "moduleEntries.updated": "Voce aggiornata",
  "moduleEntries.created": "Voce creata",
  "moduleEntries.deleted": "Voce eliminata",
  "moduleEntries.categoryPlaceholder": "es. Standard, Premium",
  "moduleEntries.imageUrl": "URL immagine",
  "moduleEntries.uploadFailed": "Caricamento fallito",
  "moduleEntries.fileTooLarge": "File troppo grande (max 20MB)",
  "moduleEntries.notConfigured": "Questo modulo non è stato configurato.",
  "moduleEntries.createFirst": "Crea la prima voce per {name}.",
  "moduleEntries.category": "Categoria",
  "moduleEntries.publication": "Pubblicazione",
  "moduleEntries.expiryDate": "Data di scadenza",
  "moduleEntries.scheduled": "Programmato",
  "moduleEntries.expired": "Scaduto",
  "moduleEntries.confirmDelete": "Eliminare davvero \"{title}\"?",
  "moduleEntries.documentUrl": "URL documento",
  "moduleEntries.autoTranslate": "Traduzione automatica",
  "moduleEntries.sourceLanguage": "Lingua di origine",
  "moduleEntries.targetLanguage": "Lingua di destinazione",
  "moduleEntries.translate": "Traduci",
  "moduleEntries.translating": "Traduzione...",
  "moduleEntries.noTranslatableTexts": "Nessun testo traducibile trovato",
  "moduleEntries.chooseOtherLanguage": "Scegli un'altra lingua di destinazione",
  "moduleEntries.textsTranslated": "{count} testi tradotti",
  "moduleEntries.translationFailed": "Traduzione fallita",
  "moduleEntries.translatableFieldsFound": "{count} campi di testo traducibili trovati",

  // --- Media ---
  "media.title": "Media",
  "media.searchPlaceholder": "Cerca per nome o testo alternativo...",
  "media.onlyImages": "Solo immagini consentite",
  "media.fileTooLarge": "File troppo grande (max 20MB)",
  "media.uploaded": "Immagine caricata",
  "media.uploadedMultiple": "Immagini caricate",
  "media.deleted": "Immagine eliminata",
  "media.saved": "Salvato",
  "media.folderExists": "La cartella esiste già",
  "media.folderCreated": "Cartella \"{name}\" creata",
  "media.folderRenamed": "Cartella rinominata in \"{name}\"",
  "media.folderDeleted": "Cartella \"{name}\" eliminata",
  "media.confirmFolderDelete": "Eliminare la cartella \"{name}\"? {count} media verranno spostati in \"Tutti\".",
  "media.confirmDelete": "Eliminare davvero?",
  "media.folderName": "Nome cartella",
  "media.all": "Tutti",
  "media.noFolder": "Senza cartella",
  "media.dropHere": "Rilascia le immagini qui",
  "media.newFolder": "Nuova cartella",
  "media.newSubfolder": "Sottocartella",
  "media.deleteFolder": "Elimina cartella",
  "media.move": "Sposta",
  "media.moved": "{count} media spostati",
  "media.noMediaInFolder": "Nessun media in \"{folder}\"",
  "media.noMedia": "Nessun media presente",
  "media.uploadToFolder": "Carica immagine in questa cartella",
  "media.uploadFirst": "Carica la prima immagine",
  "media.image": "Immagine",
  "media.filename": "Nome file",
  "media.altText": "Testo alt",
  "media.dimensions": "Dimensioni",
  "media.size": "Dimensione",
  "media.copyUrl": "Copia URL",
  "media.fullscreen": "Schermo intero",
  "media.editImage": "Modifica immagine",
  "media.altTextSeo": "Testo alt (SEO)",
  "media.altTextPlaceholder": "Descrizione dell'immagine per i motori di ricerca...",
  "media.type": "Tipo",
  "media.original": "Originale",
  "media.cropRotate": "Ritaglia / Ruota",
  "media.editImageTitle": "Modifica immagine",
  "media.rotate": "Ruota",
  "media.rotateLeft": "Ruota a sinistra",
  "media.rotateRight": "Ruota a destra",
  "media.aspect": "Formato",
  "media.editHint": "Trascina gli angoli per ritagliare. Al salvataggio tutte le varianti vengono rigenerate e ottimizzate (max 600 KB).",
  "media.applyEdit": "Applica",
  "media.reoptimize": "Riottimizza",
  "media.reoptimizeHint": "Senza ritaglio: rigenera tutte le varianti con le impostazioni attuali e comprime l'immagine.",
  "media.editSaved": "Immagine modificata",
  "media.reprocessAll": "Riottimizza tutto",
  "media.reprocessAllHint": "Rielabora tutte le immagini con le dimensioni/qualità attuali e libera spazio.",
  "media.reprocessAllConfirm": "Riottimizzare tutte le immagini? A seconda del numero può richiedere alcuni minuti.",
  "media.reprocessDone": "{done} immagini riottimizzate",
  "media.reprocessDonePartial": "{done} riottimizzate, {failed} non riuscite",
  "media.reprocessFailed": "Riottimizzazione non riuscita",
  "media.reprocessSelectedConfirm": "Riottimizzare {count} immagini selezionate?",
  "media.noImagesSelected": "Nessuna immagine nella selezione",
  "media.replace": "Sostituisci immagine",
  "media.replaceHint": "Sostituisce questa immagine ovunque venga utilizzata (pagine, moduli, gallerie). L'indirizzo resta invariato – nessuna ricerca/sostituzione necessaria.",
  "media.replaceConfirm": "Sostituire questa immagine ovunque con quella nuova? La nuova immagine apparirà automaticamente in ogni pagina e in ogni modulo che la utilizza.",
  "media.replacing": "Sostituzione in corso…",
  "media.replaced": "Immagine sostituita – aggiornata ovunque",
  "media.typeAll": "Tutti",
  "media.typeImages": "Immagini",
  "media.typePdf": "PDF",
  "media.typeDocuments": "Documenti",

  // --- Chat ---
  "chat.title": "Chat",
  "chat.empty": "Scrivi un messaggio per modificare i contenuti.",
  "chat.hint": "es. \"Cambia il titolo hero nella homepage\"",
  "chat.placeholder": "Scrivi un messaggio...",
  "chat.enterSend": "Invio = Invia, Shift+Invio = A capo",
  "chat.dropImage": "Rilascia immagine qui",
  "chat.change": "{n} modifica",
  "chat.changes": "{n} modifiche effettuate",
  "chat.mediaLibrary": "Libreria media",
  "chat.clickToInsert": "Clicca su un'immagine per inserirla, o caricane una nuova.",
  "chat.noMedia": "Nessun media presente.",
  "chat.mediaLoadError": "Impossibile caricare i media",
  "chat.imageUploaded": "Immagine caricata",
  "chat.uploadFailed": "Caricamento fallito. Riprova.",
  "chat.rateLimitError": "Limite di richieste raggiunto",
  "chat.quickHero": "Cambia testo hero",
  "chat.quickContact": "Aggiorna contatti",
  "chat.quickImage": "Sostituisci immagine",

  // --- Users (Kunde) ---
  "users.title": "Utenti",
  "users.description": "Gestisci gli utenti del tuo CMS.",
  "users.newUser": "Nuovo utente",
  "users.empty": "Nessun utente creato.",
  "users.namePlaceholder": "Mario Rossi",
  "users.emailPlaceholder": "mario@esempio.it",
  "users.noPermission": "Nessun permesso per la gestione utenti",

  // --- Settings (Kunde) ---
  "kundeSettings.title": "Impostazioni",
  "kundeSettings.contactData": "Dati di contatto",
  "kundeSettings.changePassword": "Cambia password",
  "kundeSettings.seoPerPage": "SEO per pagina",
  "kundeSettings.newPasswordPlaceholder": "Nuova password",
  "kundeSettings.minChars": "Almeno 6 caratteri",
  "kundeSettings.saved": "Impostazioni salvate",
  "kundeSettings.passwordChanged": "Password modificata con successo",
  "kundeSettings.seoSaved": "SEO salvato",
  "kundeSettings.change": "Cambia",
  "kundeSettings.language": "Lingua",

  // --- Language Switcher ---
  "lang.de": "Deutsch",
  "lang.it": "Italiano",
  "lang.en": "English",
  "lang.label": "Lingua",

  // --- Cookie Fields ---
  "cookie.titleDe": "Titolo Deutsch",
  "cookie.titleIt": "Titolo Italiano",
  "cookie.titleEn": "Titolo English",
  "cookie.textDe": "Testo Deutsch",
  "cookie.textIt": "Testo Italiano",
  "cookie.textEn": "Testo English",
  "cookie.analyticsDe": "Analytics Deutsch",
  "cookie.analyticsIt": "Analytics Italiano",
  "cookie.marketingDe": "Marketing Deutsch",
  "cookie.marketingIt": "Marketing Italiano",
  "cookie.standard": "Standard",

  // --- Custom Fields ---
  "fields.imageUploaded": "Immagine caricata",
  "fields.uploadFailed": "Caricamento fallito",
  "fields.mediaLoadFailed": "Errore caricamento media",
  "fields.noMedia": "Nessun media presente.",
  "fields.urlPlaceholder": "/uploads/... o inserisci URL",
  "fields.media": "Media",
  "fields.selectImage": "Seleziona immagine",
  "fields.selectImages": "Seleziona immagini",
  "fields.fromMediaLibrary": "Dalla libreria media",
  "fields.moveForward": "Sposta avanti",
  "fields.moveBackward": "Sposta indietro",
  "fields.acceptImages": "{count} conferma",
  "fields.addButton": "Aggiungi pulsante",
  "fields.addEntry": "Aggiungi voce",
  "fields.listFields": "Campi per voce",
  "fields.addCard": "Aggiungi card",
  "fields.addFaq": "Aggiungi FAQ",
  "fields.addLogo": "Aggiungi logo",
  "fields.entryN": "Voce {n}",
  "fields.logoN": "Logo {n}",
  "fields.yes": "Sì",
  "fields.no": "No",
  "fields.dateFrom": "Dal",
  "fields.dateTo": "Al",
  "fields.pleaseSelect": "Seleziona...",
  "fields.bold": "Grassetto",
  "fields.italic": "Corsivo",
  "fields.bulletList": "Elenco puntato",
  "fields.numberedList": "Elenco numerato",
  "fields.link": "Link",
  "fields.removeLink": "Rimuovi link",
  "fields.enterUrl": "Inserisci URL:",
  "fields.clickToRename": "Clicca per rinominare",
  "fields.duplicateField": "Duplica campo",
  "fields.removeField": "Rimuovi campo",
  "fields.videoPlaceholder": "https://youtube.com/watch?v=... o https://vimeo.com/...",
  "fields.style": "Stile",
  "fields.buttonSize": "Dimensione",
  "fields.small": "Piccolo",
  "fields.medium": "Medio",
  "fields.large": "Grande",
  "fields.iconLucide": "Icona (nome Lucide)",
  "fields.optional": "(opzionale)",
  "fields.description": "Descrizione",
  "fields.imageOptional": "Immagine (opzionale)",
  "fields.insertImage": "Inserisci immagine",
  "fields.companyName": "Nome azienda",
  "fields.internalPage": "Pagina interna",
  "fields.externalUrl": "URL esterno",
  "fields.selectPage": "Seleziona pagina...",
  "fields.searchPage": "Cerca pagina...",
  "fields.noPagesFound": "Nessuna pagina trovata",

  // --- SEO Tool (Vorschau, Checkliste, KI, Redirects, Alt-Texte) ---
  "pages.serpPreview": "Anteprima Google",
  "pages.serpDesktop": "Desktop",
  "pages.serpMobile": "Mobile",
  "pages.serpFallbackTitle": "Viene usato il titolo della pagina",
  "pages.serpFallbackDesc": "Nessuna meta description – Google mostrerà un estratto della pagina.",
  "pages.socialPreview": "Anteprima condivisione",
  "pages.socialNoImage": "Nessuna immagine di anteprima",
  "pages.fokusKeyword": "Parola chiave principale",
  "pages.fokusKeywordPlaceholder": "es. appartamento vacanze Merano",
  "pages.fokusKeywordHint": "Il termine di ricerca per cui questa pagina deve posizionarsi. Viene verificato in titolo, descrizione, intestazione, URL e testo.",
  "pages.seoChecklist": "Check SEO",
  "pages.seoScore": "{ok} di {total} superati",
  "pages.pixelWidth": "{px} px",
  "pages.aiSuggest": "Suggerisci",
  "pages.aiSuggestTitleHint": "3 proposte IA basate sul contenuto della pagina",
  "pages.aiSuggestions": "Proposte IA",
  "pages.aiSuggestLoading": "Creazione proposte…",
  "pages.aiSuggestFailed": "Proposta non riuscita",
  "pages.aiSuggestNoText": "La pagina non ha ancora testo. Aggiungi prima i contenuti.",
  "pages.apply": "Applica",
  "pages.noIndexTitle": "Non indicizzare questa pagina",
  "pages.noIndexHint": "Imposta robots: noindex, nofollow solo per questa pagina. Utile per pagine di ringraziamento/test o contenuti che non devono apparire su Google.",
  "pages.redirectTitle": "Creare un reindirizzamento?",
  "pages.redirectHint": "L'URL di questa pagina è cambiato. Per mantenere funzionanti i vecchi link e le voci Google, è consigliabile creare un reindirizzamento 301.",
  "pages.redirectCreate": "Crea reindirizzamento",
  "pages.redirectSkip": "Non ora",
  "pages.redirectCreated": "{n} reindirizzamento/i creato/i",
  "pages.redirectFailed": "Impossibile creare il reindirizzamento",
  "seoCheck.titleMissing": "Nessun meta title – viene usato il titolo della pagina",
  "seoCheck.titleLong": "Meta title troppo lungo ({px} px) – Google lo taglierà",
  "seoCheck.titleShort": "Meta title molto corto – aggiungi contesto",
  "seoCheck.titleOk": "Meta title di buona lunghezza",
  "seoCheck.descMissing": "Meta description mancante",
  "seoCheck.descLong": "Meta description troppo lunga ({n} caratteri)",
  "seoCheck.descShort": "Meta description molto corta ({n} caratteri)",
  "seoCheck.descOk": "Meta description di buona lunghezza",
  "seoCheck.h1Missing": "Nessuna intestazione (H1) – imposta un titolo hero o di sezione",
  "seoCheck.h1Ok": "Intestazione (H1) presente",
  "seoCheck.textThin": "Poco testo ({n} parole) – consigliate almeno 300",
  "seoCheck.textMedium": "{n} parole – aggiungi testo per le pagine importanti",
  "seoCheck.textOk": "Testo sufficiente ({n} parole)",
  "seoCheck.linksNone": "Nessun link interno – collega altre pagine",
  "seoCheck.linksOk": "{n} link interni",
  "seoCheck.imagesNone": "Nessuna immagine nella pagina",
  "seoCheck.imagesCount": "{n} immagini nella pagina",
  "seoCheck.imagesAltMissing": "{n} di {total} immagini senza testo alternativo (media)",
  "seoCheck.imagesOk": "Tutte le {n} immagini hanno un testo alternativo",
  "seoCheck.slugLong": "URL molto lungo – scegli uno slug più corto",
  "seoCheck.keywordNone": "Nessuna parola chiave principale impostata",
  "seoCheck.keywordTitle": "Parola chiave nel meta title",
  "seoCheck.keywordDesc": "Parola chiave nella meta description",
  "seoCheck.keywordH1": "Parola chiave nell'intestazione",
  "seoCheck.keywordSlug": "Parola chiave nell'URL",
  "seoCheck.keywordIntro": "Parola chiave nel primo paragrafo",
  "seoCheck.keywordBodyNone": "La parola chiave non compare nel testo",
  "seoCheck.keywordStuffing": "Parola chiave usata molto spesso ({n}×) – sembra innaturale",
  "seoCheck.keywordBody": "Parola chiave nel testo ({n}×)",
  "seoCheck.noIndex": "Pagina esclusa dall'indicizzazione",
  "media.altGenerate": "Suggerisci con IA",
  "media.altGenerating": "Creazione…",
  "media.altGenerated": "Testo alternativo suggerito",
  "media.altGenerateFailed": "Impossibile creare il testo alternativo",
  "media.altGenerateAll": "Testi alternativi mancanti via IA",
  "media.altGenerateAllConfirm": "Far descrivere {n} immagini senza testo alternativo dall'IA? Può richiedere alcuni minuti.",
  "media.altGenerateDone": "{done} testi alternativi creati",
  "media.altGenerateDonePartial": "{done} testi alternativi creati, {failed} non riusciti",
  "media.altGenerateNone": "Tutte le immagini hanno già un testo alternativo",
  "media.altFilterMissing": "Senza testo alternativo",
  // --- Partnerseiten ---
  "kundeSidebar.partner": "Pagine partner",
  "partner.title": "Pagine partner",
  "partner.new": "Nuovo partner",
  "partner.create": "Crea",
  "partner.created": "Partner creato",
  "partner.deleted": "Partner eliminato",
  "partner.saved": "Partner salvato",
  "partner.empty": "Nessun partner ancora",
  "partner.emptyHint": "Crea un partner per realizzare la sua pagina con il suo design.",
  "partner.confirmDelete": "Eliminare davvero il partner „{name}“? La pagina non sarà più raggiungibile.",
  "partner.nameRequired": "Inserisci un nome",
  "partner.slugInvalid": "Indirizzo non valido (solo a–z, 0–9 e trattini)",
  "partner.moduleInactive": "Il modulo Pagine partner non è attivo per questo cliente.",
  "partner.statusActive": "Attivo",
  "partner.statusDraft": "Bozza",
  "partner.openWebsite": "Vedi sul sito",
  "partner.preview": "Anteprima",
  "partner.loadError": "Impossibile caricare il partner",
  "partner.backToList": "Tutti i partner",
  "partner.mainLanguage": "princ.",
  "partner.col.name": "Partner",
  "partner.col.url": "Indirizzo",
  "partner.col.brand": "Brand ID",
  "partner.col.status": "Stato",
  "partner.tab.allgemein": "Generale",
  "partner.tab.branding": "Branding",
  "partner.tab.kontakt": "Contatto",
  "partner.tab.inhalte": "Contenuti",
  "partner.tab.angebote": "Offerte",
  "partner.tab.zusatz": "Sezioni aggiuntive",
  "partner.field.name": "Nome",
  "partner.field.slug": "Indirizzo",
  "partner.field.brandId": "TravelSeller Brand ID",
  "partner.field.partnerId": "TravelSeller Partner ID (opzionale)",
  "partner.field.aktiv": "Pagina partner attiva (pubblica)",
  "partner.field.logo": "Logo",
  "partner.field.favicon": "Favicon",
  "partner.field.primary": "Colore primario",
  "partner.field.secondary": "Colore secondario",
  "partner.field.accent": "Colore d'accento",
  "partner.field.font": "Font (Google Fonts)",
  "partner.field.telefon": "Telefono",
  "partner.field.email": "E-mail",
  "partner.field.website": "Sito del partner",
  "partner.field.adresse": "Indirizzo",
  "partner.field.heroTitel": "Banner – titolo",
  "partner.field.heroUntertitel": "Banner – sottotitolo",
  "partner.field.heroBild": "Banner – immagine",
  "partner.field.einleitungTitel": "Introduzione – titolo",
  "partner.field.einleitungText": "Introduzione – testo",
  "partner.field.galerie": "Galleria immagini",
  "partner.field.vorteile": "Vantaggi",
  "partner.field.faq": "Domande frequenti",
  "partner.slugHint": "Minuscole, cifre e trattini. Una modifica rende non validi i vecchi link.",
  "partner.brandIdHint": "Viene creato in TravelSeller per il partner. Obbligatorio prima dell'attivazione.",
  "partner.partnerIdHint": "Necessario solo se TravelSeller richiede un intermediario per le prenotazioni.",
  "partner.aktivHint": "I partner inattivi sono visibili solo tramite il link di anteprima.",
  "partner.missingTitle": "Prima dell'attivazione manca ancora:",
  "partner.previewLink": "Link di anteprima",
  "partner.previewRenew": "Genera nuovo link",
  "partner.previewHint": "Chi conosce il link vede la pagina prima dell'attivazione. Un nuovo link invalida il precedente.",
  "partner.contrastWarning": "Il testo bianco sul colore primario è poco leggibile (contrasto {ratio}:1, consigliato almeno 4,5:1). Scegli un colore più scuro.",
  "partner.fontHint": "Lascia vuoto per usare il font del sito.",
  "partner.filterIntro": "Queste offerte appaiono sulla pagina partner. Le nuove offerte in TravelSeller che corrispondono vengono aggiunte automaticamente. Separa più valori con una virgola.",
  "partner.filter.zielorte": "Destinazioni / regioni",
  "partner.filter.zielorteHint": "Nomi come in TravelSeller (tedesco), ad es. Meran und Umgebung",
  "partner.filter.themen": "Temi",
  "partner.filter.themenHint": "Titoli dei temi come in TravelSeller (tedesco)",
  "partner.filter.abflughafen": "Aeroporto di partenza (preselezionato)",
  "partner.filter.abflughafenHint": "Codice IATA, ad es. DUS. Vuoto = sceglie l'ospite.",
  "partner.filter.verpflegung": "Trattamento",
  "partner.filter.verpflegungHint": "ID trattamento TravelSeller, ad es. 2, 3",
  "partner.filter.angeboteEin": "Mostra inoltre (ID offerte)",
  "partner.filter.angeboteEinHint": "ID TravelSeller mostrati indipendentemente dal filtro",
  "partner.filter.angeboteAus": "Escludi (ID offerte)",
  "partner.filter.angeboteAusHint": "ID TravelSeller che non appaiono mai",
  "partner.platz.nachEinleitung": "Dopo l'introduzione",
  "partner.platz.nachAngeboten": "Dopo le offerte",
  "partner.platz.vorKontakt": "Prima del contatto",
  "partner.zusatzEmpty": "Nessuna sezione aggiuntiva qui.",
  "partner.zusatzPlatz": "Posizione",
  "partner.moveUp": "Su",
  "partner.moveDown": "Giù",
  "partner.zusatzConfirmRemove": "Rimuovere la sezione „{name}“?",
  "partner.zusatzAdd": "Aggiungi sezione",
  "partner.zusatzTyp": "Tipo",
  "partner.zusatzLabel": "Etichetta (solo nel CMS)",
  "partner.zusatzAddButton": "Aggiungi",
  "partner.missing.slug": "indirizzo valido",
  "partner.missing.name": "nome",
  "partner.missing.brandId": "TravelSeller Brand ID",
  "partner.missing.logo": "logo",
  "partner.missing.primary": "colore primario",
  "partner.missing.heroTitel": "titolo del banner (lingua principale)",
  "partner.adminToggleTitle": "Pagine partner",
  "partner.adminToggleHint": "Attiva la sezione „Pagine partner“ nel CMS di questo cliente. Salvato subito.",
  "partner.adminEnabled": "Pagine partner attivate",
  "partner.adminDisabled": "Pagine partner disattivate",
  "partner.translate": "Traduci",
  "partner.translateTitle": "Traduci automaticamente i contenuti",
  "partner.translateIntro": "Traduce contenuti, indirizzo e sezioni aggiuntive dalla lingua principale ({sprache}).",
  "partner.translateTargets": "Lingue di destinazione",
  "partner.translateMode": "Cosa tradurre?",
  "partner.translateOnlyEmpty": "Solo campi vuoti",
  "partner.translateOverwrite": "Ritraduci tutto (sovrascrive le traduzioni esistenti)",
  "partner.translateHint": "La traduzione viene inserita nell'editor. Controlla e poi salva.",
  "partner.translateStart": "Traduci",
  "partner.translateRunning": "Traduzione …",
  "partner.translateDone": "{anzahl} testi tradotti – controlla e salva",
  "partner.translatePartial": "{anzahl} testi tradotti, {fehlend} no – controlla e riprova",
  "partner.translateNothing": "Niente da tradurre – tutti i campi hanno già un testo",
  "partner.translateNoSource": "Nella lingua principale non c'è ancora testo",
  "partner.translateError": "Traduzione non riuscita",
  "partner.field.heroButtons": "Banner – pulsanti",
  "partner.field.kennzahlen": "Cifre sotto il banner (titolo = numero, testo = descrizione)",
  "partner.field.schritteTitel": "„Come funziona“ – titolo",
  "partner.field.schritte": "„Come funziona“ – passaggi",
  "partner.field.kontaktTitel": "Fascia contatto – titolo",
  "partner.field.kontaktText": "Fascia contatto – testo",
  "partner.platz.nachBanner": "Dopo il banner",
};

export default it;
